module.exports = __webpack_public_path__ + "img/hubin.060d8ee2.jpg";